import React from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import emptyStateImg from '@panel/commons/assets/img/sin-avisos.svg';
import emptyStateImgUB from '@panel/commons/assets/img/sin-avisos-ub.svg';
import { isMobileDevice } from '@panel/commons/helpers';
import { useSelector } from 'react-redux';
import { Button } from '@panel/commons';
import { userInfoSelectors } from '@panel/core/src/state/ducks/user';

const siteId = process.env.REACT_APP_BUILD_SITE;

const isMobile = isMobileDevice();

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 70vh;
  width: 100%;
`;

const EmptyMsg = styled.div`
  & p {
    max-width: 320px;
    white-space: normal;
    display: flex;
    flex-direction: column;
    text-align: center;
  }
`;

const Img = styled.div`
  background-image: ${() => {
    if (siteId === 'UBPE') return `url(${emptyStateImgUB})`;
    return `url(${emptyStateImg})`;
  }};
  height: ${isMobile ? 220 : 316}px;
  width: ${isMobile ? 199 : 286}px;
  background-repeat: no-repeat;
  background-size: cover;
`;

const Title = styled.p`
  font-size: ${isMobile ? 20 : 24}px;
  font-weight: bold;
  margin-top: 30px;
`;

const Subtitle = styled.p`
  font-family: Hind;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 26px;
  text-align: center;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 35px;
  a:first-child {
    margin: 0;
    ${isMobile &&
      css`
        width: 100%;
      `}
  }
`;

function EmptyState() {
  const { t } = useTranslation();
  const { publisherTypeId, isSeeker } = useSelector(userInfoSelectors.getuserInfoState);

  const userIsParticular =
    (publisherTypeId === '1' || isSeeker) &&
    ['DVPE', 'UBPE', 'ZPAR', '24MX', 'IWBR', 'WIBR', 'PLEC', 'CAPA', 'CMBR', 'VAMX'].includes(siteId);

  return (
    <Wrapper>
      <Img data-panel='panel-emptyState-image' />
      <EmptyMsg>
        <Title data-panel='panel-emptyState-title'>{t('panel.emptyState.title')}</Title>
        <Subtitle data-panel='panel-emptyState-subtitle'>{t('panel.emptyState.subtitle')}</Subtitle>
        <ButtonContainer>
          <Button
            buttonType='solidButton'
            dataPanel='avisos-emptyState-postingEdit'
            linkRef={userIsParticular ? '/panel/publicador/principales/operacionypropiedad' : '/publicar.bum'}
            text={t('panel.emptyState.CTA')}
          />
        </ButtonContainer>
      </EmptyMsg>
    </Wrapper>
  );
}

export default EmptyState;
